module.exports = __webpack_public_path__ + "img/icon-otf.9c21f1c5.svg";